/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SettingsPageChatMessageTemplateViewQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageChatMessageTemplateViewQuery = { viewer: { chatMessageTemplates: Array<{ guid: string, label: string, body: string, selections: Array<string> }> } };

export type SettingsPageDeleteChatMessageTemplateMutationVariables = Exact<{
  guid: string | number;
}>;


export type SettingsPageDeleteChatMessageTemplateMutation = { deleteChatMessageTemplate: Array<{ guid: string, label: string, body: string, selections: Array<string> }> };


export const SettingsPageChatMessageTemplateViewDocument = gql`
    query SettingsPageChatMessageTemplateView {
  viewer {
    chatMessageTemplates {
      guid
      label
      body
      selections
    }
  }
}
    `;

/**
 * __useSettingsPageChatMessageTemplateViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageChatMessageTemplateViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageChatMessageTemplateViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageChatMessageTemplateViewQuery();
 */
export function useSettingsPageChatMessageTemplateViewQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageChatMessageTemplateViewQuery, SettingsPageChatMessageTemplateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageChatMessageTemplateViewQuery, SettingsPageChatMessageTemplateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageChatMessageTemplateViewQuery, SettingsPageChatMessageTemplateViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageChatMessageTemplateViewQuery, SettingsPageChatMessageTemplateViewQueryVariables>(SettingsPageChatMessageTemplateViewDocument, {}, options);
}
export function useSettingsPageChatMessageTemplateViewLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageChatMessageTemplateViewQuery, SettingsPageChatMessageTemplateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageChatMessageTemplateViewQuery, SettingsPageChatMessageTemplateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageChatMessageTemplateViewQuery, SettingsPageChatMessageTemplateViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageChatMessageTemplateViewQuery, SettingsPageChatMessageTemplateViewQueryVariables>(SettingsPageChatMessageTemplateViewDocument, {}, options);
}
export type SettingsPageChatMessageTemplateViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageChatMessageTemplateViewQuery, SettingsPageChatMessageTemplateViewQueryVariables>;
export const SettingsPageDeleteChatMessageTemplateDocument = gql`
    mutation SettingsPageDeleteChatMessageTemplate($guid: ID!) {
  deleteChatMessageTemplate(guid: $guid) {
    guid
    label
    body
    selections
  }
}
    `;

/**
 * __useSettingsPageDeleteChatMessageTemplateMutation__
 *
 * To run a mutation, you first call `useSettingsPageDeleteChatMessageTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageDeleteChatMessageTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSettingsPageDeleteChatMessageTemplateMutation({
 *   variables: {
 *     guid: // value for 'guid'
 *   },
 * });
 */
export function useSettingsPageDeleteChatMessageTemplateMutation(options: VueApolloComposable.UseMutationOptions<SettingsPageDeleteChatMessageTemplateMutation, SettingsPageDeleteChatMessageTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SettingsPageDeleteChatMessageTemplateMutation, SettingsPageDeleteChatMessageTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SettingsPageDeleteChatMessageTemplateMutation, SettingsPageDeleteChatMessageTemplateMutationVariables>(SettingsPageDeleteChatMessageTemplateDocument, options);
}
export type SettingsPageDeleteChatMessageTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SettingsPageDeleteChatMessageTemplateMutation, SettingsPageDeleteChatMessageTemplateMutationVariables>;